import React from 'react'
import '../Styles/style.css'


const LoaderComp = () => {

    return(
        <div id="loader" className="loader">
                <div className="lds-ripple"><div></div><div></div></div>
        </div>
    )
}

export default LoaderComp;